import type { ClientRelease } from '../../../shared/types/collection'

export type ReleaseUpdateReason =
	| 'details'
	| 'favorite'
	| 'history'
	| 'hydration'
	| 'rating'

export type ReleaseUpdateDetail = {
	// Local changes repaint views; only confirmed writes invalidate server queries.
	confirmed: boolean
	reason: ReleaseUpdateReason
	release: ClientRelease
}

export function emitReleaseUpdated(
	release: ClientRelease,
	reason: ReleaseUpdateReason,
	confirmed = true,
): void {
	window.dispatchEvent(
		new CustomEvent<ReleaseUpdateDetail>('collection:release-updated', {
			detail: { confirmed, reason, release },
		}),
	)
}

export function getReleaseUpdateDetail(event: Event): ReleaseUpdateDetail {
	return (event as CustomEvent<ReleaseUpdateDetail>).detail
}
